import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  IconButton, Tooltip,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import { uiSlice } from '@/domain/ui/redux';

/**
 * プロパティ
 */
export type Props = {
  /** タイトル */
  title: string,
}

const Title: React.FC<Props> = ({
  title,
}) => {
  const dispatch = useDispatch();
  return (
    <h3>
      <Tooltip title="トップ画面に戻る">
        <IconButton size="large" onClick={() => dispatch(uiSlice.actions.setPage('home'))}>
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>
      <span>{title}</span>
    </h3>
  );
};

export default Title;
